import { Dialog } from '@/components/ui/dialog'

import { IntroducingBrokersTable, SelectIntroducingBrokerEvent } from './IntroducingBrokersTable'

interface IntroducingBrokersProps {
  filterId?: string
  onSelect: (selectIntroducingBrokerEvent: SelectIntroducingBrokerEvent) => void
  onClose: () => void
}

export const IntroducingBrokersModal: React.FC<IntroducingBrokersProps> = (props) => (
  <Dialog open onOpenChange={(open) => !open && props.onClose()}>
    <IntroducingBrokersTable
      filterId={props.filterId}
      onSelect={props.onSelect}
      onClose={props.onClose}
    />
  </Dialog>
)
